import types from '../types';

export const updateModuleTable = (model, fields) => ({
	type: types.moduleTables.UPDATE_MODULE_TABLE,
	payload: {model, fields}
})
